const ACTION_LABELS = {
    ADMIN_LOGIN: 'Вход в аккаунт',
    ADMIN_USER_CREATE: 'Создание администратора',
    ADMIN_USER_UPDATE: 'Редактирование администратора',
    ADMIN_USER_DELETE: 'Удаление администратора',
    SENDER_BROADCAST: 'Массовая рассылка',
    SENDER_TO_USER: 'Отправка сообщения пользователю',
    PROMO_CREATE: 'Создание промоакции',
    PROMO_EDIT: 'Редактирование промоакции',
    PROMO_DELETE: 'Удаление промоакции',
    TELEGRAM_USER_DELETE: 'Удаление пользователя',
    TELEGRAM_USER_UPDATE: 'Редактирование пользователя',
    TELEGRAM_USER_BALANCE_UPDATE: 'Обновление баланса',
    TAP_SETTINGS_UPDATE: 'Обновление настроек Piggy Tap',
    TAP_POOL_RESET: 'Сброс пула тапов Piggy Tap',
};

export const getActionLabel = (action) => {
    if (!action) return '—';
    return ACTION_LABELS[action] || action;
};

export default ACTION_LABELS;

